import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {AuthGuard} from '@app/shared';
import {AddSaleComponent} from '@app/modules/sale/add-sale/add-sale.component';
import {SaleReturnComponent} from '@app/modules/sale/sale-return/sale-return.component';
import {SaleReturnListComponent} from '@app/modules/sale/sale-return-list/sale-return-list.component';
import {SaleListComponent} from '@app/modules/sale/sale-list/sale-list.component';

const routes: Routes = [
  {
    path: '',
    children: [
      {
        path: 'add-sale',
        loadComponent: () => AddSaleComponent,
        canActivate: [AuthGuard],
        data: {level: 2, path: '/add-sale'}
      },
      {
        path: 'add-sale/:/:id',
        loadComponent: () => AddSaleComponent,
        canActivate: [AuthGuard],
        data: {level: 2, path: '/add-sale'}
      },
      {
        path: 'sale-return',
        loadComponent: () => SaleReturnComponent,
        canActivate: [AuthGuard],
        data: {level: 2, path: '/sale-return'}
      },
      {
        path: 'sale-list',
        loadComponent: () => SaleListComponent,
        canActivate: [AuthGuard],
        data: {level: 2, path: '/sale-list'}
      },
      {
        path: 'sale-return-list',
        loadComponent: () => SaleReturnListComponent,
        canActivate: [AuthGuard],
        data: {level: 2, path: '/sale-return-list'}
      },
    ],
    runGuardsAndResolvers: 'always',
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})

export class SaleRoutingModule {
}
